import { Injectable, DOCUMENT, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  private document = inject<Document>(DOCUMENT);

  getWindow(): Window & typeof globalThis {
    return this.document.defaultView!;
  }
}
